<template>
  <div v-if="developer.image.length > 0" class="pb-3 text-center">
    <div class="d-block d-sm-none ratio ratio-1x1 w-50 h-50 mx-auto">
      <img :src="'data:image;base64,' + developer.image[0].image" class="d-block rounded-circle object-fit-cover"
           :alt="developer.name">
    </div>
    <div class="d-none d-sm-block ratio ratio-1x1 w-25 h-25 mx-auto">
      <img :src="'data:image;base64,' + developer.image[0].image" class="d-block rounded-circle object-fit-cover"
           :alt="developer.name">
    </div>
  </div>
  <h3 v-if="developer.name">{{ developer.name }}</h3>
  <p v-if="developer.description">{{ developer.description }}</p>
  <h4 v-if="developer.housingComplexes.length > 0" class="pb-2">ЖК у застройщика: {{
      developer.housingComplexes.length
    }}</h4>
  <div class="row">
    <!--suppress JSUnresolvedVariable -->
    <div v-for="item in developer.housingComplexes" :key="item.id" class="col-xl-3 col-lg-4 col-md-3 col-sm-4 col-6">
      <developers-hc-card :housingComplexes="item"/>
    </div>
  </div>
</template>

<script>
import {useRoute} from "vue-router";
import {onMounted, computed} from "vue";
import {useHead} from "@unhead/vue";
import useDeveloper from "@/hooks/useDeveloper";
import DevelopersHcCard from "@/components/pages/developers/DevelopersHcCard";

export default {
  name: "developer",
  components: {DevelopersHcCard},
  setup() {
    const route = useRoute()
    const id = route.params.id

    const {getDeveloper, developer} = useDeveloper()

    // Метатеги
    const pageTitle = computed(() => {
      return developer.value?.name
        ? `${developer.value.name} - застройщик | P-L-E.ru`
        : "Профиль застройщика | P-L-E.ru";
    });

    const pageDescription = computed(() => {
      if (!developer.value) return "Информация о застройщике на P-L-E.ru";

      let desc = `Застройщик ${developer.value.name}`;
      if (developer.value.housingComplexes?.length) {
        desc += `, ${developer.value.housingComplexes.length} жилых комплексов`;
      }
      if (developer.value.description) {
        desc += `. ${developer.value.description.substring(0, 160)}...`;
      }
      return desc;
    });

    const canonicalUrl = computed(() => {
      return `https://p-l-e.ru/developer/${id}`;
    });

    const ogImage = computed(() => {
      return developer.value?.images?.[0]?.image
        ? `data:image;base64,${developer.value.images[0].image}`
        : 'https://p-l-e.ru/logo.png';
    });

    useHead({
      title: pageTitle,
      meta: [
        { name: 'description', content: pageDescription },
        { property: 'og:title', content: pageTitle },
        { property: 'og:description', content: pageDescription },
        { property: 'og:url', content: canonicalUrl },
        { property: 'og:image', content: ogImage },
        { property: 'og:type', content: 'website' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: pageTitle },
        { name: 'twitter:description', content: pageDescription },
        { name: 'twitter:image', content: ogImage }
      ],
      link: [
        { rel: 'canonical', href: canonicalUrl }
      ],
      script: [{
        type: 'application/ld+json',
        innerHTML: computed(() => {
          if (!developer.value) return '{}';

          return JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": developer.value.name,
            "description": developer.value.description,
            "url": canonicalUrl.value,
            "logo": ogImage.value,
            "numberOfEmployees": {
              "@type": "QuantitativeValue",
              "value": developer.value.employeesCount || ""
            }
          });
        })
      }]
    });

    onMounted(() => {
      getDeveloper(id)
    });

    return {developer}
  }
}
</script>

<style scoped>
/* Стили остаются без изменений */
</style>